import React, { useRef } from "react";

// reactstrap components
import {
  Button,
  Label,
  FormGroup,
  Input,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
} from "reactstrap";
import ReactToPdf from "react-to-pdf";
import { Grid } from "@material-ui/core";

// core components
import ExamplesNavbar from "components/Navbars/ExamplesNavbar.js";
import DemoFooter from "components/Footers/DemoFooter.js";
import ReactToPrint from "react-to-print";
import MapLink from "../../assets/map.pdf";

const SocietyMaps = () => {
  const componentRef = useRef();
  const ref = React.createRef();
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.classList.add("society-maps-page");
    return function cleanup() {
      document.body.classList.remove("society-maps-page");
    };
  });
  return (
    <>
      <ExamplesNavbar notHome={true} />

      {/* <div
        className="section project-map"
        ref={ref}
        style={{ width: 1200, height: 1200 }}
      >
                  <ReactToPdf targetRef={ref} filename="MirajMap.pdf">
                  {({ toPdf }) => (
                    <Button className="print-btn" onClick={toPdf}>
                      PRINT MAP
                    </Button>
                  )}
                </ReactToPdf>
        <Container>
          <Row>
            <Col lg={12}>
              <div className="d-flex justify-content-between align-items-center">
                <h2
                  className="title my-3"
                  style={{ textAlign: "center", width: "100%" }}
                >
                  PROJECT MAP
                </h2>
              </div>
            </Col>
            <Col lg={12}>
              <div ref={componentRef}>
              
              </div>
            </Col>
          </Row>
        </Container>
        <div className="content-center">
          <img
            src={require("assets/img/map-legend@2x.png")}
            className="d-lg-none d-md-none d-block"
          />
        </div>
    
      </div>
       */}
      {/* <div className="map-legend d-none d-lg-block">
        <img src={require("assets/img/map-legend@2x.png")} className="" />
      </div> */}
      <div style={{ marginBottom: 100 }}></div>

      <Grid
        container
        direction="column"
        alignItems="flex-end"
        style={{ width: "95%" }}
      >
        {/* <ReactToPdf targetRef={ref} filename="MirajMap.pdf">
          {({ toPdf }) => (
            <Button className="print-btn" onClick={toPdf}>
              PRINT MAP
            </Button>
          )}
        </ReactToPdf> */}
        <Button
          className="print-btn"
          onClick={() => {
            window.location.href = MapLink;
          }}
        >
          {" "}
          PRINT MAP
        </Button>
        {/* <a
          style={{
            background: "black",
            color: "white",
            textDecoration: "none",
            padding: 5,
          }}
          href={}
        >
          {" "}
          PRINT MAP
        </a> */}
      </Grid>

      <Grid container direction="column" alignItems="center">
        <div style={{ width: 800, height: 1000 }}>
          <Grid container direction="row" ref={ref}>
            <h2
              className="title my-3"
              style={{ textAlign: "center", width: "100%" }}
            >
              PROJECT MAP
            </h2>
            <Grid item md={3} xs={3} lg={3} xl={3}>
              <Grid
                container
                direction="row"
                alignItems="flex-end"
                style={{ height: "50%" }}
              >
                <img
                  src={require("assets/img/map-legend@2x.png")}
                  // className="d-lg-none d-md-none d-block"
                />
              </Grid>
            </Grid>
            <Grid item md={9} xs={9} lg={9} xl={9}>
              <img
                // className="project-map"
                style={{ width: 600, height: 1000 }}
                src={require("assets/img/map.png")}
              />
            </Grid>
          </Grid>
        </div>
      </Grid>
    </>
  );
};

export default SocietyMaps;
